"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSeriesDomainsSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var get_settings_specs_1 = require("../../../../state/selectors/get_settings_specs");
var utils_1 = require("../utils/utils");
var get_api_scale_configs_1 = require("./get_api_scale_configs");
var get_specs_1 = require("./get_specs");
var getDeselectedSeriesSelector = function (state) { return state.interactions.deselectedDataSeries; };
exports.computeSeriesDomainsSelector = re_reselect_1.default([
    get_specs_1.getSeriesSpecsSelector,
    getDeselectedSeriesSelector,
    get_settings_specs_1.getSettingsSpecSelector,
    get_specs_1.getSmallMultiplesIndexOrderSelector,
    get_api_scale_configs_1.getScaleConfigsFromSpecsSelector,
], function (seriesSpecs, deselectedDataSeries, settingsSpec, smallMultiples, scaleConfigs) {
    return utils_1.computeSeriesDomains(seriesSpecs, scaleConfigs, deselectedDataSeries, settingsSpec.orderOrdinalBinsBy, smallMultiples, settingsSpec.sortSeriesBy);
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=compute_series_domains.js.map